import ApiService from './ApiService'

export const getCompanyApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }

        // Add company filter from navbar
        if (data.company) {
            datas.maestro_company_code = data.company
        }

        // Add company filters
        if (data.filters) {
            // Company name filter
            if (data.filters.name) {
                datas.name = data.filters.name
            }
            // Account code filter
            if (data.filters.account_code) {
                datas.account_code = data.filters.account_code
            }
            // Display name filter
            if (data.filters.display_name) {
                datas.display_name = data.filters.display_name
            }
            // Parent company name filter (if still needed)
            if (data.filters.parent_company_name) {
                datas.parent_company_name = data.filters.parent_company_name
            }
        }
    }
    return ApiService.get('/api/v1/machship/companies/', datas)
}

export const getConsignmentApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }

        // Add company filter from navbar
        if (data.company) {
            datas.maestro_company_code = data.company
        }

        // Add new filter parameters
        if (data.filters) {
            // Company name filter
            if (data.filters.company_name) {
                datas.company_name = data.filters.company_name
            }

            // Carrier and service name filter
            if (data.filters.carrier_and_service_name) {
                datas.carrier_and_service_name = data.filters.carrier_and_service_name
            }

            // Status name filter
            if (data.filters.tracking_status_name) {
                datas.tracking_status_name = data.filters.tracking_status_name
            }

            // Created date range filters
            if (data.filters.created_date_from) {
                datas.created_date_from = data.filters.created_date_from
            }
            if (data.filters.created_date_to) {
                datas.created_date_to = data.filters.created_date_to
            }

            // Completed date status filter (Yes/No)
            if (data.filters.completed_date_status !== undefined && data.filters.completed_date_status !== null) {
                datas.completed_date_status = data.filters.completed_date_status
            }
        }
    }
    return ApiService.get('/api/v1/machship/consignments/', datas)
}

export const getFinacialInvoiceApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
    }
    return ApiService.get('/api/v1/machship/financial-invoices/', datas)
}
